import {IssueGroupingKey, usePlantStoppages} from '@domain/stoppages'
import {DataContentWrapper} from '@hconnect/common/containers'
import {PageContainer} from '@hconnect/uikit/src/lib2'
import {useParams} from 'react-router'

import {EquipmentStoppageDetailsForCode} from '../containers'
import {useDowntimePlantId} from '../providers'

type PathParameter = {
  groupId: string
  groupType:
    | IssueGroupingKey.MAIN_EQUIPMENT
    | IssueGroupingKey.EQUIPMENT_NUMBER
    | IssueGroupingKey.STOPPED_MAIN_EQUIPMENT
  stoppageCode: string
}

export const DowntimeStoppagesDetailsForCode = () => {
  const plantId = useDowntimePlantId()
  const {groupType, groupId, stoppageCode} = useParams<PathParameter>()
  if (!groupId || !groupType || !stoppageCode) throw new Error('Missing url parameter')
  if (
    groupType !== IssueGroupingKey.MAIN_EQUIPMENT &&
    groupType !== IssueGroupingKey.EQUIPMENT_NUMBER &&
    groupType !== IssueGroupingKey.STOPPED_MAIN_EQUIPMENT
  ) {
    throw new Error('Unsupported groupType url parameter')
  }

  const {
    data: stoppageConfig,
    isInitialLoading,
    isError,
    refetch,
    isRefetching
  } = usePlantStoppages(plantId)

  return (
    <PageContainer>
      <DataContentWrapper
        showLoader={isInitialLoading}
        data={stoppageConfig}
        retryFunction={() => void refetch()}
        isError={isError}
        isRefetching={isRefetching}
      >
        <EquipmentStoppageDetailsForCode
          stoppageConfig={stoppageConfig}
          groupType={groupType}
          groupId={groupId}
          stoppageCode={stoppageCode}
          downtimeStoppageDetailsBasePath={'../..'}
        />
      </DataContentWrapper>
    </PageContainer>
  )
}
